import { render, staticRenderFns } from "./DrawerFiltroReceber.vue?vue&type=template&id=0329dbfe&scoped=true&"
import script from "./DrawerFiltroReceber.vue?vue&type=script&lang=js&"
export * from "./DrawerFiltroReceber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0329dbfe",
  null
  
)

export default component.exports